import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../../../infrastructure/config';
import { LocalstorageService } from '../../core/localstorage/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthinterceptorService implements HttpInterceptor {

  constructor(private localStorageService: LocalstorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('shareme')) {
      return next.handle(req);
    }

    const request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${this.localStorageService.getLocalStorageItem(Config.lsTokenKey)}`
      }
    });

    return next.handle(request);
  }
}

// intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//   if (!req.url.includes('shareme')) { return next.handle(req); }
//
// const debugParam = 'XDEBUG_SESSION_START=PHPSTORM';
// const modifiedUrl = req.url.includes('?')
//   ? `${req.url}&${debugParam}`
//   : `${req.url}?${debugParam}`;
//
// const request = req.clone({
//   url: modifiedUrl ,
//   setHeaders: {
//     Authorization: `Bearer ${this.localStorageService.getLocalStorageItem(Config.lsTokenKey)}`
//   }
// });
//
// return next.handle(request);

// }
